module.exports = kolibriCoreAppGlobal.lib.apiResource;